
















// vue
import { defineComponent, onMounted, ref } from '@vue/composition-api';

// components
import EventType from '@/vue3/components/layer-tree/EventType.vue';

export default defineComponent({
    components: { 
        EventType, 
    },
    props: {
        toggleArchivedGeoRecord: {
            type: Function,
            default: () => {},
        },
        archiveEvents: {
            type: Array,
            default: [],
        },
    },
    setup(props: any) {
        // reactive
        const selectedOptionId = ref<number | null>(null);

        // methods
        const toggleSelection = (id: number): void => {
            selectedOptionId.value = selectedOptionId.value === id ? null : id;

            props.toggleArchivedGeoRecord(selectedOptionId.value);
        };

        const refreshEvents = async () => {
            if (!props.archiveEvents) return;

            props.archiveEvents.sort((a: any, b: any) => {
                let eventNameA = a.name.toLowerCase();
                let eventNameB = b.name.toLowerCase();
                if (eventNameA < eventNameB) {
                    return -1;
                }
                if (eventNameA > eventNameB) {
                    return 1;
                }
                return 0;
            });
        };

        const isSelected = (id: number): boolean => {
            return selectedOptionId.value === id;
        };

        // lifecycle
        onMounted(async () => {
            await refreshEvents();
        });

        return {
            toggleSelection,
            isSelected,
        };
    },
});
